import React from "react";
import { Box, Collapse, Divider, Button } from "@mui/material";
import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Image from "next/image";

interface MoreOptionsProps {
  moreOptionsOpen: boolean;
  handleMoreOptionsClick: () => void;
  handleModalInformationOpen: () => void;
  handleOnClickRedeemed: () => void;
  redeemStatus: string;
}
const MoreOptions: React.FC<MoreOptionsProps> = ({
  moreOptionsOpen,
  handleMoreOptionsClick,
  handleModalInformationOpen,
  handleOnClickRedeemed,
  redeemStatus,
}) => {
  const { i18n } = useLingui();
  return (
    <Box>
      <Button
        onClick={handleMoreOptionsClick}
        data-testid="more-options-button"
        endIcon={moreOptionsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        sx={{
          fontSize: "17px  !important",
          fontWeight: "500",
          pl: "0",
          "&:hover": {
            textDecoration: "none",
            color: "primary.main",
          },
          transition: "all 0.3s ease",
        }}
      >
        {t(i18n)`More Options`}
      </Button>
      <Collapse in={moreOptionsOpen} timeout="auto" unmountOnExit>
        <Divider />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            fontWeight: 500,
            gap: 0,
          }}
        >
          <Image src="/vinfo.svg" alt="Logo" width={19} height={19} />
          <Button
            onClick={handleModalInformationOpen}
            data-testid="information-button"
            sx={{
              textDecoration: "none",
              color: "inherit",
              fontWeight: 500,
              fontSize: "17px",
              "&:hover": {
                textDecoration: "none",
                color: "primary.main",
              },
              transition: "all 0.3s ease",
            }}
          >
            {t(i18n)`Information`}
          </Button>
        </Box>

        {redeemStatus !== "1" && (
          <>
            <Divider />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                fontWeight: 500,
                fontSize: "17px",
                gap: 0,
              }}
            >
              <Image src="/vmarked.svg" alt="Logo" width={19} height={19} />
              <Button
                sx={{
                  color: "black",
                  fontWeight: "500",
                  fontSize: "17px  !important",
                  "&:hover": {
                    textDecoration: "none",
                    color: "primary.main",
                  },
                  transition: "all 0.3s ease",
                }}
                data-testid="mark-redeemed-button"
                onClick={handleOnClickRedeemed}
              >
                {t(i18n)`Mark as redeemed`}
              </Button>
            </Box>
          </>
        )}
      </Collapse>
    </Box>
  );
};
export default MoreOptions;
